/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-11 16:51:10
 * @LastEditTime: 2024-09-26 20:01:57
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\register\index.tsx
 * @Description: 注册页面
 */
import { CommmonGet, CommmonPost } from "@/util/network/api";
import { CheckIdCard, CheckPhone } from "@/util/public";
import { Checkbox, Form, message } from "antd";
import { LgButton, LgInput } from "lancoo-web-ui";
import { useEffect, useState } from "react";
import { service } from "../data";
import NameIcon from '../images/姓名.svg';
import SecureIcon from '../images/安全.svg';
import PasswordIcon from '../images/密码.svg';
import PhoneIcon from '../images/手机.svg';
import CardIcon from "../images/证件.svg";
import Protocol from "./Protocol";

function Register(props: any) {
    const {
        form,
        onLogin,
        setIsloading
    } = props;

    const [countdown, setCountdown] = useState<number>(60); // 倒计时秒数
    const [timingShow, setTimingShow] = useState<boolean>(false);
    const [isShowProtocol, setIsShowProtocol] = useState(false);
    const [readedProtocol, setReadedProtocol] = useState(false);

    useEffect(() => {
        const formData = form.getFieldsValue();
        form.setFieldsValue({
            ...formData,
            username: '',
            idCard: '',
            firstPwd: '',
            secondPwd: '',
            phone: '',
            code: ''
        });
    }, []);

    const submit = () => {
        if (!readedProtocol) {
            message.warning("请阅读注册协议");
            return
        }
        form.validateFields().then((values) => {
            if (values.password !== values.secondPwd) {
                message.warning('两次密码输入不一致', 2);
                return;
            }
            setIsloading(true);
            CommmonPost(service.register, values).then((res) => {
                message.success("注册成功");
                onLogin();
            }).catch((error) => {
                console.log(error);
                if (error.msg) {
                    message.warning(error.msg, 2);
                } else {
                    message.warning('注册失败', 2);
                }
            })
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            setIsloading(false);
        });
    }

    /**
    * @description: 获取注册验证码
    * @param {*} void
    * @return {*}
    */
    const getLoginCode = (): void => {
        // 禁用获取验证码按钮
        const formData = form.getFieldsValue();
        if (formData.phone) {
            if (!CheckPhone(formData.phone)) {
                message.warning('手机号格式有误', 2);
                return;
            }
            setIsloading(true);
            CommmonGet(service.sendLoginSmsCode, {
                phone: formData.phone,
                type: '3'
            }).then(res => {
                message.success("发送成功");
                startCountdown();
            }).catch(err => {
            }).finally(() => {
                setIsloading(false);
            });
        } else {
            message.warning('请输入手机号', 2);
        }
    };
    /**
    * @description: 倒计时
    * @return {*}
    */
    const startCountdown = () => {
        setTimingShow(true)
        let timer = setInterval(() => {
            setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000);

        setTimeout(() => {
            setTimingShow(false)
            clearInterval(timer);
            setCountdown(60); // 重置倒计时秒数为60
        }, countdown * 1000);
    };
    /**
    * @description: 按钮回车事件
    * @param {*} event
    * @return {*}
    */
    const handleKeyDown = event => {
        if (event.keyCode === 13) {
            console.log('Enter key pressed');
            // 在这里执行你想要执行的操作
            submit()
        }
    }

    return (
        <>
            <Form.Item
                style={{ position: 'relative', marginBottom: 0 }}
                className='form_icon'
            >
                <div className='form_icon_div' style={{ background: `url(${NameIcon}) no-repeat center` }} />
                <Form.Item
                    name="username"
                    rules={[
                        { required: true, message: '用户名不能为空!' },
                        () => ({
                            validator(_, value) {
                                if (!value || (value.length < 19 && value.length > 7)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('用户名长度为8-18位'));
                            },
                        })
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <LgInput
                        bigWidth
                        maxLength={18}
                        input={{ placeholder: "请输入用户名" }}
                        size='oversized'
                        style={{ height: 48 }}
                    />
                </Form.Item>
            </Form.Item>

            <Form.Item
                style={{ position: 'relative', marginBottom: 0 }}
                className='form_icon'
            >
                <div className='form_icon_div' style={{ background: `url(${CardIcon}) no-repeat center` }} />
                <Form.Item
                    name="idCard"
                    rules={[
                        { required: true, message: '身份证号不能为空!' },
                        () => ({
                            validator(_, value) {
                                if (!value || !CheckIdCard(value)) {
                                    return Promise.resolve();
                                } else if (value && CheckIdCard(value)) {
                                    return Promise.reject(new Error(CheckIdCard(value)));
                                }
                                return Promise.reject(new Error('身份证格式有误'));
                            },
                        }),
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <LgInput
                        bigWidth
                        maxLength={50}
                        input={{ placeholder: "请输入身份证号" }}
                        size='oversized'
                        style={{ height: 48 }}
                    />
                </Form.Item>
            </Form.Item>

            <Form.Item
                style={{ position: 'relative', marginBottom: 0 }}
                className='form_icon'
            >
                <div className='form_icon_div' style={{ background: `url(${PasswordIcon}) no-repeat center` }} />
                <Form.Item
                    name="password"
                    rules={[
                        { required: true, message: '请输入密码' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('secondPwd') === value || getFieldValue('secondPwd').length === 0) {
                                    return Promise.resolve();
                                }
                                form.setFields([
                                    {
                                        name: 'secondPwd',
                                        errors: [],
                                    },
                                ]);
                                return Promise.reject(new Error('密码不一致'));
                            },
                        })
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <LgInput
                        bigWidth
                        maxLength={18}
                        input={{ placeholder: "请输入密码(建议6-8位数字)", type: 'password' }}
                        size='oversized'
                        style={{ height: 48 }}
                    />
                </Form.Item>
            </Form.Item>

            <Form.Item
                style={{ position: 'relative', marginBottom: 0 }}
                className='form_icon'
            >
                <div className='form_icon_div' style={{ background: `url(${PasswordIcon}) no-repeat center` }} />
                <Form.Item
                    name="secondPwd"
                    // rules={[{ required: true, message: '请再次输入密码' }]}
                    rules={[
                        { required: true, message: '请再次输入密码' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value || getFieldValue('password').length === 0) {
                                    return Promise.resolve();
                                }
                                form.setFields([
                                    {
                                        name: 'password',
                                        errors: [],
                                    },
                                ]);
                                return Promise.reject(new Error('密码不一致'));
                            },
                        })
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <LgInput
                        bigWidth
                        maxLength={18}
                        input={{ placeholder: "请确认密码(建议6-8位数字)", type: 'password' }}
                        size='oversized'
                        style={{ height: 48 }}
                    />
                </Form.Item>
            </Form.Item>
            <Form.Item
                style={{ position: 'relative', marginBottom: 0 }}
                className='form_icon'
            >
                <div className='form_icon_div' style={{ background: `url(${PhoneIcon}) no-repeat center` }} />
                <Form.Item
                    name="phone"
                    rules={[
                        { required: true, message: '请输入手机号' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || CheckPhone(value)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('手机号格式有误'));
                            },
                        }),
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <LgInput
                        bigWidth
                        maxLength={18}
                        input={{ placeholder: "请输入手机号" }}
                        size='oversized'
                        style={{ height: 48 }}
                    />
                </Form.Item>
            </Form.Item>

            <Form.Item
                style={{ position: 'relative', marginBottom: 0 }}
                className='form_icon form_iconMa'
            >
                <div className='form_icon_div' style={{ background: `url(${SecureIcon}) no-repeat center` }} />
                <Form.Item
                    style={{ position: 'relative', marginBottom: 0 }}
                >
                    <Form.Item
                        name="code"
                        rules={[{ required: true, message: '请输入验证码' }]}
                        style={{ marginBottom: 16 }}
                    >
                        <LgInput
                            bigWidth
                            maxLength={18}
                            input={{ placeholder: "请输入验证码" }}
                            size='oversized'
                            onKeyDown={handleKeyDown}
                            style={{ height: 48 }}
                        />
                    </Form.Item>
                    {timingShow ?
                        <div
                            className='form_ss'
                            style={{
                                color: '#999999',
                                cursor: 'default'
                            }}
                        >
                            ({countdown}秒后重新获取)
                        </div> :
                        <div
                            onClick={getLoginCode}
                            className='form_ss'
                        >
                            获取验证码
                        </div>
                    }
                </Form.Item>
            </Form.Item>
            <div style={{ marginBottom: '10px' }}>
                <Checkbox
                    checked={readedProtocol}
                    onChange={() => setReadedProtocol(!readedProtocol)}
                    style={{ marginRight: '5px' }}
                ></Checkbox>
                我已阅读
                <span
                    style={{ color: "#09f", cursor: 'pointer' }}
                    onClick={() => {
                        setIsShowProtocol(true)
                        setReadedProtocol(true)
                    }}
                >
                    注册协议
                </span>
                ，同意注册。
            </div>
            <Form.Item style={{ marginBottom: 12 }}>
                <LgButton
                    onClick={submit}
                    backgroundType='opacification'
                    type='info'
                    size='super'
                    style={{ justifyContent: 'center', width: 360 }}
                >
                    注册
                </LgButton>
            </Form.Item>
            <div>
                <span style={{ color: '#999999' }}>已有账号，</span>
                <span className='onclik_cls' onClick={onLogin}>立即登录</span>
            </div>
            <Protocol visible={isShowProtocol} onClose={() => setIsShowProtocol(false)}></Protocol>
        </>

    )
}

export default Register
